import React, { useEffect, useState } from "react";
import './AccessRequestModal.css';
import { requestAccess as requestAccessToHomey } from '../util/fetchHomeys';

const AccessRequestModal = ({ open, onClose, homey }) => {
    const [show, setShow] = useState(false);
    const [isRequesting, setIsRequesting] = useState(false);

    const handleRequestAccess = () => {
        if(isRequesting) return;
        setIsRequesting(true);
        
        Promise.all([
            requestAccessToHomey(homey),
            new Promise((resolve) => setTimeout(resolve, 1000)),
        ])
            .then(() => {
                onClose();
            })
            .catch(error => {
                alert(`${error.message}`);
            })
            .finally(() => {
                setTimeout(() => {
                    setIsRequesting(false);
                }, 1000);
            });
    }

    useEffect(() => {
        if (open) {
            requestAnimationFrame(() => setShow(true));
        } else {
            requestAnimationFrame(() => setShow(false));
        }
    }, [open]);

    if(!homey) return null;

    return (
        <div className={`AccessModalOverlay ${show ? "open" : ""}`} onClick={onClose}>
            <div className="AccessModalContent" onClick={(e) => e.stopPropagation()}>
                <div className="AccessModalIcon">
                    <img src="/mobile_icon.svg" alt="Mobile App Icon" />
                </div>
                <h2>Request Temporary Access</h2>
                <p>The owner of <strong>{homey.name}</strong> will be sent a push notification with your request for access.</p>
                <p>Once they have accepted your request, you’ll receive a push notification yourself.</p>
                <div className="AccessModalTip">
                    <p>
                        If they didn't receive a notification, please ask them to check their iOS or Android permissions.<br /><br />
                        Alternatively, they can give you access by navigating to More → Family & Guests in the mobile app.
                    </p>
                </div>
                <button className={`AccessModalButton ${isRequesting ? 'is-loading' : ''}`} onClick={handleRequestAccess}>Send Push Notification</button>
            </div>
        </div>
    );
};

export default AccessRequestModal;
